import React from "react";
import "../css/sliderBrand.css";
import yanmar1 from "../img/yanmar1.webp";
import cummins2 from "../img/cummins2.webp";
import volvo3 from "../img/volvo3.webp";
import mtu4 from "../img/mtu4.webp";
import johnD5 from "../img/johnD5.webp";
import phasor6 from "../img/phasor6.webp";
import maspower7 from "../img/maspower7.webp";
import balmar8 from "../img/balmar8.webp";
import aquadrive9 from "../img/aquadrive9.webp";

const SliderBrands = () => {
  return (
    <div className="logos">
      <div className="logos-slide">
        <img src={yanmar1} alt={"Yanmar marine engines logo Panama"} />
        <img
          src={cummins2}
          alt="Cummins diesel engines logo Panama Canal services"
        />
        <img src={volvo3} alt="Volvo Penta marine systems logo Panama" />
        <img src={mtu4} alt="Mtu marine engines logo Panama" />
        <img src={johnD5} alt="John Deere marine engines logo Panama" />
        <img src={phasor6} alt="Phasor Marine generator systems logo Panama" />
        <img
          src={maspower7}
          alt="Mas Power Marine generators logo for boats in Panama"
        />
        <img src={balmar8} alt="Balmar marine engines logo Panama" />
        <img
          src={aquadrive9}
          alt="Aquadrive antivibration system logo Panama"
        />
      </div>
      <div className="logos-slide">
        <img src={yanmar1} alt={"Yanmar marine engines logo Panama"} />
        <img
          src={cummins2}
          alt="Cummins diesel engines logo Panama Canal services"
        />
        <img src={volvo3} alt="Volvo Penta marine systems logo Panama" />
        <img src={mtu4} alt="Mtu marine engines logo Panama" />
        <img src={johnD5} alt="John Deere marine engines logo Panama" />
        <img src={phasor6} alt="Phasor Marine generator systems logo Panama" />
        <img
          src={maspower7}
          alt="Mas Power Marine generators logo for boats in Panama"
        />
        <img src={balmar8} alt="Balmar marine engines logo Panama" />
        <img
          src={aquadrive9}
          alt="Aquadrive antivibration system logo Panama"
        />
      </div>
    </div>
  );
};

export default SliderBrands;
